import React, { Fragment, FunctionComponent } from "react";
import BackgroundMediaProps from "./BackgroundMediaProps.interface";

import BackgroundImage from "./blocks/BackgroundImage/BackgroundImage";
import BackgroundVideo from "./blocks/BackgroundVideo/BackgroundVideo";
import BackgroundGradient from "./blocks/BackgroundGradient/BackgroundGradient";
import BackgroundPattern from "./blocks/BackgroundPattern/BackgroundPattern";

const BACKGROUND_MEDIA_TYPES: { [key: string]: any } = {
    "nestedBackgroundImage": BackgroundImage,
    "nestedBackgroundVideo": BackgroundVideo,
    "nestedBackgroundGradient": BackgroundGradient,
    "nestedBackgroundPattern": BackgroundPattern
};

const BackgroundMedia: FunctionComponent<BackgroundMediaProps> = (props) => {
    const contentType = props?.content?._contentType;

    if (!contentType) {
        return (
            <Fragment></Fragment>
        );
    }

    const DynamicBackgroundMedia = BACKGROUND_MEDIA_TYPES[contentType];

    return (
        <Fragment>
            {DynamicBackgroundMedia && props ? (
                <DynamicBackgroundMedia {...props} />
            ) : null}
        </Fragment>
    );
};

export default BackgroundMedia;